import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "../pages/AccountStyles";
import ReactTooltip from "react-tooltip";
import TariffContent from "../data/tariffContent";

const renderHeader = (days, rate, level, warning = null) => {
  let rateTitle = rate;
  if (rate === "import") {
      rateTitle = "price";
  }

  return (
    <div className={css(styles.twoColumn)}>
     {!warning && (<h5 className={css(styles.headerTitleLight)}>
        {days === "all" ? "Every Day" : days}
      </h5>)}
      {warning && (<span>{warning}</span>)}
      <div className={css(styles.editWrapper)}>
        <a
          href={`/account/${level}/tariff/edit-time/${days}/${rate}`}
          className={css(styles.link)}
        >
          <img
            src={"/icons/pencil.svg"}
            className={css(styles.linkIcon)}
            alt=""
          />
          Edit {rateTitle}
        </a>
      </div>
    </div>
  );
};

const formatTime = (time) => {
  // var h = Math.floor(time / 60);
  // var m = time % 60;

  const paddedTime = time.toString().padStart(4, "0");
  return paddedTime.slice(0, 2) + ":" + paddedTime.slice(2);
};

export default class TariffData extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { data, title, rate, level, used_tariff } = this.props;

    let content = null;

    if (title.toLowerCase() in TariffContent) {
      content = TariffContent[title.toLowerCase()].split(".")[0];
    }

    return (
      <>
        <h4
          className={css([styles.headerTitle, styles.headerTitleBottomMargin])}
        >
          {title}
          {content && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              data-tip={content}
              style={{
                width: "15px",
                verticalAlign: "middle",
                marginLeft: "0.5em",
                color: "rgb(0, 197, 255)",
              }}
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </h4>

        {!data && (
          <>
            {renderHeader("all", rate, level, !used_tariff && `There are no ${title} set`)}
              {used_tariff && (<div className={css([styles.twoColumn, styles.smallMarginBottom])}>
              <p
                className={css([
                  styles.paragraphSmall,
                  styles.smallMarginBottom,
                ])}
              >
                All Day
              </p>
              <p
                className={css([
                  styles.paragraphSmall,
                  styles.smallMarginBottom,
                ])}
              >
                £{used_tariff && parseFloat(used_tariff[0].prices).toFixed(2)}
                kWh
              </p>
            </div>)}
            {used_tariff && (<p className={css([
              styles.paragraphXSmall,
              styles.smallMarginBottom,
              styles.block,
            ])}>You do not have any {title} set, the price shown is a default tariff</p>)}
          </>
        )}

        {data &&
          data.map((energy, i) => {
            return (
              <div key={i}>
                {renderHeader(energy.days, rate, level)}
                {energy.prices.map((price, i) => {
                  return (
                    <div
                      key={i}
                      className={css([
                        styles.twoColumn,
                        styles.smallMarginBottom,
                      ])}
                    >
                      <p
                        className={css([
                          styles.paragraphSmall,
                          styles.smallMarginBottom,
                          styles.paragraphLeading,
                        ])}
                      >
                        {energy.rate_names[i]}
                      </p>
                      <p
                        className={css([
                          styles.paragraphSmall,
                          styles.smallMarginBottom,
                          styles.paragraphCenter,
                        ])}
                      >
                        {energy.prices.length > 1 &&
                          formatTime(energy.times[i])}
                      </p>
                      <p
                        className={css([
                          styles.paragraphSmall,
                          styles.smallMarginBottom,
                          styles.paragraphTrailing,
                        ])}
                      >
                        £{price.toFixed(2)}kWh
                      </p>
                    </div>
                  );
                })}
              </div>
            );
          })}

        <ReactTooltip
          overridePosition={(
            { left, top },
            currentEvent,
            currentTarget,
            node
          ) => {
            const d = document.documentElement;
            left = Math.min(d.clientWidth - node.clientWidth, left);
            top = Math.min(d.clientHeight - node.clientHeight, top);
            left = Math.max(0, left);
            top = Math.max(0, top);
            return { top, left };
          }}
        />
      </>
    );
  }
}
